var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderEventIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22c-.55 0-1.02-.196-1.412-.587A1.93 1.93 0 013 20V6c0-.55.196-1.02.588-1.412A1.93 1.93 0 015 4h1V3c0-.283.096-.52.288-.712A.972.972 0 017 2c.283 0 .52.095.713.288A.96.96 0 018 3v1h8V3c0-.283.096-.52.288-.712A.972.972 0 0117 2c.283 0 .52.095.713.288A.96.96 0 0118 3v1h1c.55 0 1.021.196 1.413.588.392.392.588.863.587 1.412v14c0 .55-.196 1.021-.587 1.413A1.92 1.92 0 0119 22H5zm0-2h14V10H5v10zm3-6a.965.965 0 01-.712-.288A.972.972 0 017 13c0-.283.095-.52.288-.712A.97.97 0 018 12h8c.283 0 .521.096.713.288.192.192.288.43.287.712 0 .283-.097.52-.288.713A.957.957 0 0116 14H8zm0 4a.965.965 0 01-.712-.288A.972.972 0 017 17c0-.283.095-.52.288-.712A.97.97 0 018 16h5c.283 0 .521.096.713.288.192.192.288.43.287.712 0 .283-.097.52-.288.713A.957.957 0 0113 18H8z",
    fill: "#CDCDCD"
  })));
}

export default SvgHeaderEventIcon;